import SectionHeading from "@/pages/home/components/SectionHeading";
import { processSteps } from "@/mocks/home";

export default function Process() {
  return (
    <section id="process" className="w-full bg-background-50 py-14 md:py-24">
      <div className="w-full px-4 md:px-10">
        <SectionHeading
          eyebrow="投稿与核验流程"
          title="一条线索，要过四道关"
          desc="从你按下提交的那一刻起，线索会进入一条固定流程。我们公开每一步在做什么，也接受公众对结果的监督。"
        />

        <ol className="mt-10 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {processSteps.map((step, index) => (
            <li
              key={step.id}
              className="reveal relative bg-background-100 rounded-lg p-5 md:p-6 border border-background-200 flex flex-col gap-4"
              style={{ animationDelay: `${index * 0.08}s` }}
            >
              <div className="flex items-center justify-between">
                <span className="w-12 h-12 rounded-md bg-primary-100 text-primary-600 flex items-center justify-center">
                  <i className={`${step.icon} text-2xl`}></i>
                </span>
                <span className="font-heading text-3xl font-bold text-background-400">{step.id}</span>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-950">{step.title}</h3>
              <p className="text-sm leading-relaxed text-foreground-600">{step.desc}</p>
            </li>
          ))}
        </ol>

        <p className="reveal mt-8 md:mt-10 flex items-start gap-3 text-xs md:text-sm text-foreground-600 bg-secondary-50 border border-secondary-200 rounded-lg px-4 md:px-5 py-4">
          <i className="ri-error-warning-line text-secondary-600 text-lg leading-5"></i>
          <span>
            温馨提示：请勿提交涉及无关第三方隐私、未成年人信息或明显捏造的内容。经查证属恶意造谣的投稿，将被永久列入黑名单。
          </span>
        </p>
      </div>
    </section>
  );
}